<app-alert></app-alert>
<app-cambiar-password-modifi *ngIf="validarEtapa(EnumEtapas.CambiarPassword)"
[dataUsuario]="dataUsuario"
(enventoAcualizarData)="actualizarClaveUsuario($event)" 
></app-cambiar-password-modifi>
<app-cambiar-password-ok 
*ngIf="validarEtapa(EnumEtapas.Ok)"
></app-cambiar-password-ok>


